import { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { useSessao } from "../estado/sessao";
import { FalhaApi } from "../api";

export function VerificarEmail() {
  const { verificarEmail } = useSessao();
  const [params] = useSearchParams();
  const token = params.get("token");

  const [status, setStatus] = useState<"verificando" | "ok" | "erro">("verificando");
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus("erro");
      setErro("Link de verificação incompleto.");
      return;
    }
    verificarEmail(token)
      .then(() => setStatus("ok"))
      .catch((e) => {
        setStatus("erro");
        setErro(e instanceof FalhaApi ? e.message : "Não foi possível confirmar o e-mail.");
      });
    // Roda uma única vez, na montagem — verificarEmail não deve ser reexecutado a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (status === "ok") return <Navigate to="/" replace />;

  return (
    <div className="tela-login">
      <div className="cartao cartao-login">
        <h1 className="marca">
          Lembr<span>Ai</span>
        </h1>
        {status === "verificando" && <p>Confirmando seu e-mail…</p>}
        {status === "erro" && (
          <>
            <div className="alerta alerta-erro" role="alert">
              {erro}
            </div>
            <p className="rodape-login">
              <Link to="/entrar">Voltar para o login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
